import React, { useContext, useEffect, useState } from "react";
import PageTitle from "../../Components/PageTitle";
import { NoRecords } from "../../Components/Shimmer";
import { ConfigContext } from "../../Context/ConfigContext";
import Select from "react-select";
import axios from "axios";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { currentDateAndTime, encodeData, findModuleByRoute } from "../../Constants/constants";
import { useRowSelect } from "react-table";
import { formatDate } from "../../Components/InputElements";
import { useLocation, useNavigate } from "react-router-dom";
import { decodeData } from "../../Constants/constants";

const PayrollProcess = () => {
const { apiURL, apiHeaderFile, apiHeaderJSON,permissions } = useContext(ConfigContext);
  const locationParams = useLocation();
  const queryParams = new URLSearchParams(locationParams.search);
  const encodedData = queryParams.get("abs");
  let routeId = findModuleByRoute(permissions,"SalaryReport");
  console.log("routeId One=>>",routeId);
  routeId=routeId?.id;
  console.log("routeId",routeId);
  const decodedData = encodedData ? decodeData(encodedData,permissions) : []; 
 
  const navigate= useNavigate();
  const [rows, setRows] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [isChanged, setIsChanged] = useState(false);
  const [isSalChanged, setIsSalChanged] = useState(false);
  const [showAttendanceButton, setShowAttendanceButton] = useState(false);
  const [showSalaryRegistterButton, setShowSalaryRegistterButton] =
    useState(false);
  const [loadingFilter, setLoadingFilter] = useState(false);
  const [loadingPayroll, setLoadingPayroll] = useState(false);
  const [processAttendanceModal, setProcessAttendanceModal] = useState(false);
  const [processSalaryModel, setProcessSalaryModel]  = useState(false);
  const [loadingAttednace, setLoadingAttednace] = useState(false);
  const [loadingSalary, setLoadingSalary] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);
  const [shiftRows, setShiftRows] = useState([]);
  const [salaryRegister, setSalaryRegister] = useState([]);
  const [attendanceMonthOptions, setAttendanceMonthOptions] = useState([]);
  const [department, setDepartment] = useState([]);
  const [location, setLocation] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [salaryRows, setSalaryRows] = useState([]);
  const [salaryHeaders, setSalaryHeaders] = useState([]);
  const [salaryRowColumns, setSalaryRowColumns] = useState([]);
  const [isPayRollProcess, setIsPayRollProcess] = useState(true);
  const[loadingExport,setLoadingExport]=useState(true);
  // const []
  const [filter, setFilter] = useState({
    keyword: null,
    month: null,
    attendanceMonth: null,
    location: null,
    department: null,
    location_shift_id: null,
  });
  const [pagination, setPagination] = useState({
    next: false,
    prev: false,
    page: 1,
    limit: 10,
    total_records: 0,
    total_pages: 0,
    loadingList: false,
  });
  const [salaryPagination, setsalaryPagination] = useState({
    next: false,
    prev: false,
    page: 1,
    limit: 10,
    total_records: 0,
    total_pages: 0,
    loadingList: false,
  });
  const limitOptions = [10, 25, 50, 100, 200, 500];

  const getList = () => {
    // console.log(
    //   `pagination?.limit,pagination?.page`,
    //   pagination?.limit,
    //   pagination?.page
    // );
    const headers = apiHeaderJSON;
    console.log("filter?.month", filter?.month);
    axios
      .get(`${apiURL}Payrolls/GetEmployeesList`, {
        params: {
          limit: pagination?.limit || 10,
          page: pagination?.page || 1,
          keyword: filter?.keyword,
          month: filter?.month,
          location_id: filter?.location,
          department_id: filter?.department,
          location_shift_id: filter?.location_shift_id,
        },
        headers,
      })
      .then((response) => {
        var data = response?.data?.data;
        if (data?.success === true) {
          console.log(data);
          setPagination({
            ...pagination,
            next: data?.next,
            prev: data?.prev,
            page: data?.page,
            total_records: data?.total_records,
            total_pages: data?.total_pages,
            loadingList: false,
          });
          setRows(data?.data);
        } else {
          setPagination({ ...pagination, loadingList: false });
          console.log(`data?.message`, response?.data);
          if (response?.data?.message === "Month year selection is required.") {
            Swal.fire({
              title: `<strong>Failed</strong>`,
              text: response?.data?.message,
              icon: "error",
              showConfirmButton: true,
              allowOutsideClick: false,
            });
          }
        }
      });
  };


  const salaryRegisterGetList = () => {
    const headers = apiHeaderJSON; // Keep headers clean
    setLoadingSalary(true);

    axios
      .get(`${apiURL}Payrolls/GetSalaryRegister`, {
        params: {
          date: currentDateAndTime(),  // ✅ Ensure date is inside params
          month: filter?.month,
          department_id: filter?.department,
          location_id: filter?.location,
        },
        headers,
      })
      .then(async (response) => {
        const data = response.data;
        console.log("salaryRegisterGetList response:", data);

        let headerTitles = Array.isArray(data?.registerArray) && data?.registerArray?.length > 0 ? data?.registerArray[0] : [];

        if (data?.success === true) {
            let salaryList = data?.registerArray || [];
            if (salaryList.length > 0) {
                setSalaryHeaders(headerTitles);
                salaryList.shift(); // Remove headers row
                setSalaryRows(salaryList);
            }

            if (headerTitles?.length > 0 && salaryList?.length > 0) {
                let { success, registerArray, message, month } = data;
                registerArray = [headerTitles, ...salaryList]; // Reconstruct array
                console.log("headerTitles final", headerTitles);
                console.log("final", registerArray);
                setSalaryRegister({ success, registerArray, message, month });
            }
        } else {
          console.error("Error fetching salary register data");
        }
        setLoadingSalary(false);
      })
      .catch((error) => {
        setLoadingSalary(false);
        console.error("Error during API call:", error);
      });
};

  // const salaryRegisterGetList = () => {
  //   // const headers = apiHeaderJSON;
  //   const headers = {
  //     ...apiHeaderJSON,
  //     date: currentDateAndTime() 
  // };
  //   setLoadingSalary(true);
  //   axios
  //     .get(`${apiURL}Payrolls/GetSalaryRegister`, {
  //       params: {
  //         // date: currentDateAndTime(),
  //         month: filter?.month,
  //         department_id: filter?.department,
  //         location_id: filter?.location,
  //       },
  //       headers,
  //     })
  //     .then(async (response) => {
  //       const data = response.data;
  //       console.log("salaryRegisterGetList response:", data);
  //       // console.log("salaryRegisterGetList data?.registerArray:", data?.registerArray[0]);
  //       let headerTitles= Array.isArray(data?.registerArray) && data?.registerArray?.length>0 && data?.registerArray[0];
  //       if (data?.success === true) {
  //           let salaryList=data?.registerArray;
  //           // console.log("data?.registerArray=>>",salaryList);
  //           if(Array.isArray(salaryList) && salaryList?.length>0){
  //               // console.log("salaryList[0]=>>",salaryList[0]);
  //               // console.log("data?.registerArray.shift()=>>",salaryList.shift());
  //               setSalaryHeaders(data?.registerArray[0]);
  //               salaryList.shift();
  //               // console.log("salaryList=>>",salaryList);
  //               setSalaryRows(salaryList);
  //           }
  //           if(headerTitles?.length>0 && salaryList?.length>0){
  //             let { success, registerArray, message, month } = data;
  //             registerArray= [headerTitles,...salaryList];
  //             console.log("headerTitles final", headerTitles);
  //             console.log("final", registerArray);
  //             setSalaryRegister({success, registerArray, message, month});
  //           }
            
  
        
  //       //   console.log("Fetched salaryRegister data:", data?.registerArray);
  //       } else {
          
  //         console.error("Error fetching salary register data");
  //       }
  //       setLoadingSalary(false);
  //     })
  //     .catch((error) => {
  //       setLoadingSalary(false);
  //       console.error("Error during API call:", error);
  //     });
  // };
  const getMonthFilterList = () => {
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Payrolls/GetSalaryMonthYearFilterDataFromAttendance`, {
        params: {
          date: currentDateAndTime(),
        },
        headers,
      })
      .then(async (response) => {
        var data = response.data;
        // console.log("getMonthFilterList", data);
        if (data?.success === true) {
          setMonthOptions(data?.filterData);
          setShowAttendanceButton(data?.show_run_attendance_button || false);
          
          if (data?.show_run_attendance_button) {
            getAttendanceMonthFilterList();
          }
          // setFilter({
          //     ...filter,
          //     month: data?.filterData[0]?.value || null
          // });
        } else {
        }
      });
  };
  const getAttendanceMonthFilterList = () => {
    const headers = apiHeaderJSON;
    axios
      .get(
        `${apiURL}Payrolls/GetAttendanceMonthYearFilterDataFromInternalAttendance`,
        {
          params: {
            date: currentDateAndTime(),
          },
          headers,
        }
      )
      .then(async (response) => {
        var data = response.data;
        // console.log("getMonthFilterList", data);
        if (data?.success === true) {
          setAttendanceMonthOptions(data?.filterData);
          // setFilter({
          //     ...filter,
          //     month: data?.filterData[0]?.value || null
          // });
        } else {
        }
      });
  };

  const getDepartmentFilterList = () => {
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Payrolls/GetDepartments`, {
        params: {
          date: currentDateAndTime(),
        },
        headers,
      })
      .then(async (response) => {
        var data = response.data;
        // console.log("getDepartmentFilterList", data);
        if (data?.success === true) {
          let row = data?.departments?.map((val) => {
            return { value: val?.department_id, label: val?.department_title };
          });
          // row?.splice(0, 0, { value: "All", label: "All" });
          // let allDepartmentRow = data?.departments?.map((val) => {
          //     return val?.department_id
          // });
          // allDepartmentRow = allDepartmentRow?.join(",");
          setDepartment(row);
        } else {
        }
      });
  };
  const getLocationFilterList = () => {
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Payrolls/GetLocations`, {
        params: {
          date: currentDateAndTime(),
        },
        headers,
      })
      .then(async (response) => {
        var data = response.data;
        // console.log("getLocationFilterList", data);
        if (data?.success === true) {
          let row = data?.locations?.map((val) => {
            return { value: val?.location_id, label: val?.location_title };
          });
          setLocation(row);
        } else {
        }
      });
  };

  const getShiftList = () => {    
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetShiftList `, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
            const temp=data.data.map((row) => ({
                value: row.company_location_shift_id,
                label: row.company_location_shift_name,
              }))
          setShiftRows(temp);
        }
      });
  };


  useEffect(() => {
    getShiftList();
    getMonthFilterList();
    getDepartmentFilterList();
    getLocationFilterList();
  }, []); 
  
  

  const handleMultiSelect = (fieldName, selectedOptions) => {
    const ids = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    // console.log(ids.join(','))
    setFilter((prevFormData) => ({
      ...prevFormData,
      [fieldName]: ids.join(","),
    }));
    // console.log("ids", ids);
    // if (!ids || ids?.length === 0) {
    //     setIsChanged(true);
    // }
  };

  const handleSlabChange = (index, fieldName, value) => {
    const updatedRows = [...rows];
    updatedRows[index] = {
      ...updatedRows[index],
      [fieldName]: value,
    };
    setRows(updatedRows);
  };

  const handleAttendance = () => {
    setLoadingAttednace(true);
    const headers = apiHeaderJSON;
    // console.log("filter?.month", filter?.month);
    axios
      .get(`${apiURL}Payrolls/RunAttendaceForPayroll`, {
        params: {
          month: filter?.attendanceMonth,
          location_shift_id: filter?.location_shift_id,
          date: currentDateAndTime(),
        },
        headers,
      })
      .then((response) => {
        var data = response?.data;
        if (data?.success === true) {
          // console.log(data);
          getMonthFilterList();
          setLoadingAttednace(false);
          setFilter({
            ...filter,
            location_shift_id: "",
            department: "",
            location: "",
          });
          setProcessAttendanceModal(false);
        } else {
          setLoadingAttednace(false);
        }
        Swal.fire({
          title: `<strong>${data?.success ? "Success" : "Failed"}</strong>`,
          text: response.data.message,
          icon: data?.success ? "success" : "error",
          showConfirmButton: true,
        });
      })
      .catch((error) => {
        console.log(error);
        setLoadingAttednace(false);
      });
  };

  const handlePayroll = () => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to process payroll? And please check that Attendance and leave is locked.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes!",
      cancelButtonText: "No!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoadingPayroll(true);
        let data = {
          monthYear: filter?.month,
          date: currentDateAndTime(),
          employeeList: selectedRows,
        };
        const headers = apiHeaderJSON;
        console.log(data);
        axios
          .post(`${apiURL}Payrolls/ProcessPayroll`, data, {
            headers,
            onUploadProgress: (progressEvent) => {
              const { loaded, total } = progressEvent;
              console.log(`Loaded: ${loaded}, Total: ${total}`);
              if (total) {
                const percentCompleted = Math.round((loaded / total) * 90);
                console.log(`Upload Progress: ${percentCompleted}%`);
                setUploadProgress(percentCompleted);
              }
            },
            //   onUploadProgress: (progressEvent) => {
            //     const { loaded, total } = progressEvent;
            //     if (total) {
            //       const percentCompleted = Math.round((loaded / total) * 100);
            //       setUploadProgress(percentCompleted);
            //     }
            //   },
          })
          .then((response) => {
            const { success } = response.data;
            // console.log("handlePayroll ~ response =======>>>", response);
            if (success === true) {
              setUploadProgress(100);
              Swal.fire({
                title: `<strong>${success ? "Success" : "Failed"}</strong>`,
                text: response.data.message,
                icon: success ? "success" : "error",
                showConfirmButton: true,
                allowOutsideClick: false,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Optional: You can perform any action here after OK is clicked
                  setSelectedRows([]);
                  setLoadingPayroll(false);
                  getList();
                  setUploadProgress(0);
                }
              });
            } else {
              Swal.fire({
                title: `<strong>${success ? "Success" : "Failed"}</strong>`,
                text: response.data.message,
                icon: success ? "success" : "error",
                showConfirmButton: true,
                allowOutsideClick: false,
              }).then((result) => {
                if (result.isConfirmed) {
                  setUploadProgress(0);
                  // Optional: Action after the OK button is clicked
                  // setLoadingPayroll(false);
                }
              });
            }
            setLoadingPayroll(false);
          })
          .catch((e) => {
            console.log(e);
            setLoadingPayroll(false);
          });
      } else {
        setLoadingPayroll(false);
      }
    });
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(
        rows.map((row) => {
          return {
            employee_id: row?.employee_id,
            employee_name: row?.employee_name,
            employee_code: row?.employee_code,
          };
        })
      );
    } else {
      setSelectedRows([]);
    }
  };
  const handleInputChange = (e) => {
    setFilter({
      ...filter,
      [e.target.name]: e.target.value,
    });
    if (!e.target.value) {
      setIsChanged(true);
    }
  };
  const handleCheckboxChange = (employeeData) => {
    const isSelected = selectedRows.some(
      (row) => row.employee_id === employeeData?.employee_id
    );
    if (isSelected) {
      setSelectedRows(
        selectedRows.filter(
          (row) => row.employee_id !== employeeData?.employee_id
        )
      );
    } else {
      setSelectedRows([
        ...selectedRows,
        {
          employee_id: employeeData?.employee_id,
          employee_name: employeeData?.employee_name,
          employee_code: employeeData?.employee_code,
        },
      ]);
    }
  };

  // useEffect(() => {
  //     console.log("selectedRows", selectedRows);
  // }, [selectedRows]);

  const handleSelectAllDropdown = (action) => {
    if (action === "select-all") {
      setSelectedRows(rows.map((row) => row.employee_id));
    } else if (action === "deselect-all") {
      setSelectedRows([]);
    }
  };

  const handleInputSearch = (e) => {
    getList();
  };

  const handleClearAll = () => {
    setFilter({
      keyword: null,
      month: null,
      location: null,
      department: null,
      location_shift_id: null,
    });
    setRows([]);
    setSalaryRows([]);
    // setIsChanged(true);
  };

  useEffect(
    (type) => {
      if (type === "salary") {
        if (isSalChanged && filter?.month) {
          salaryRegisterGetList();
          setIsSalChanged(false);
        }
      } else {
      }
      if (isChanged && filter?.month) {
        getList();
        setIsChanged(false);
      }
    },
    [isChanged]
  );

  const handleExcelDownload = async () => {
    const headers = apiHeaderJSON;

    // Swal.fire({
    //     title: 'Please wait...',
    //     html: 'Your file is being prepared for download.',
    //     allowOutsideClick: false,
    //     didOpen: () => {
    //         Swal.showLoading();
    //     }
    // });

    // axios.get(`${apiURL}Payrolls/GetSalaryRegister`, {
    //     params: {
    //         month: filter?.month,
    //         department_id: filter?.department,
    //         location_id: filter?.location
    //     },
    //     headers
    // })
    //     .then(async (response) => {
            const { success, registerArray, message, month } = salaryRegister;
            console.log("registerArray",registerArray);
            if (success === true && Array.isArray(registerArray) && registerArray?.length>0) {
                // Assuming `registerArray` is an array of objects (representing rows of data)
                const filteredData = registerArray.slice(0); // Use this if you need to remove specific rows

                // Explicitly set the headers based on the object keys (remove the index row)
                const headers = Object.keys(filteredData[0]);

                // Convert the filtered data to a worksheet without auto-indexing
                const worksheet = XLSX.utils.json_to_sheet(filteredData, { skipHeader: true });

                // Create a new workbook and append the worksheet
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, worksheet, 'Salary Register');

                // Save the file with the correct format
                XLSX.writeFile(wb, `${localStorage.getItem("company_code")} Salary Register ${month}.xlsx`);

                Swal.close();
                Swal.fire({
                    title: `<strong>Success</strong>`,
                    text: message,
                    icon: 'success',
                    showConfirmButton: true,
                    allowOutsideClick:false,
                });
            } else {
                Swal.close();
                Swal.fire({
                    title: `<strong>Failed</strong>`,
                    text: message,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick:false,
                });
            }
        // })
        // .catch((error) => {
        //     Swal.close();
        //     Swal.fire({
        //         title: `<strong>Failed</strong>`,
        //         text: error.response ? error.response.message : error.message,
        //         icon: 'error',
        //         showConfirmButton: true
        //     });
        // });
}
  const handlePrev = (type) => {
    if (type === "salary") {
      if (salaryPagination?.prev === true) {
        setsalaryPagination({
          ...salaryPagination,
          page: salaryPagination?.page - 1,
        });
        setIsSalChanged(true);
      }
    } else {
      if (pagination?.prev === true) {
        // getList();
        setPagination({
          ...pagination,
          page: pagination?.page - 1,
        });
        setIsChanged(true);
      }
    }
  };
  const handleNext = (type) => {
    if (type === "salary") {
      if (salaryPagination?.next === true) {
        setsalaryPagination({
          ...salaryPagination,
          page: salaryPagination?.page + 1,
        });
        setIsSalChanged(true);
      }
    }
    if (pagination?.next === true) {
      // getList();
      setPagination({
        ...pagination,
        page: pagination?.page + 1,
      });
      setIsChanged(true);
    }
  };
  const handleChange = (type) => {
    if (type === "salary") {
      setsalaryPagination({
        ...salaryPagination,
        page: parseInt(type.target.value),
      });
      setIsSalChanged(true);
    }
    setPagination({
      ...pagination,
      page: parseInt(type.target.value),
    });
    setIsChanged(true);
  };
  const handleLimitChange = (type) => {
    if (type === "salary") {
      setsalaryPagination({
        ...salaryPagination,
        limit: parseInt(type.target.value),
        page: 1,
      });
      setIsSalChanged(true);
      setsalaryPagination({
        ...salaryPagination,
        limit: parseInt(type.target.value),
        page: 1,
      });
      setIsSalChanged(true);
    } else {
      setPagination({
        ...pagination,
        limit: parseInt(type.target.value),
        page: 1,
      });
      setIsChanged(true);
      setPagination({
        ...salaryPagination,
        limit: parseInt(type.target.value),
        page: 1,
      });
      setIsChanged(true);
    }
  };

  return (
    <div class="main-content">
      <div class="page-content">
        <div className="container-fluid">
          <br />
          <PageTitle title={`Payroll Process`} primary={`Home`} />
            <div className="card">
              <div className="card-body">
                <div className="row mb-1">
                {/* <div className='col-md-2'>
                    <label> Select Month </label>
                    <Select
                        options={monthOptions}
                        value={
                            filter?.month
                                ? monthOptions.find(option => option.value === filter?.month)
                                : null
                        }
                        onChange={(selectOption) => setFilter({ ...filter, month: selectOption?.value })}
                        placeholder={`Select Month`} />
                </div> */}
                    <div className="col-md-3">
                         <label htmlFor="keyword">Search By Name</label>
                        <div className="input-group">
                          <input
                          type="search"
                          className="form-control"
                          onChange={handleInputChange}
                          name="keyword"
                          value={filter?.keyword}
                          aria-label="Recipient's username"
                          aria-describedby="button-addon2"
                          placeholder="Enter Name"
                        />
                    <button
                      className="btn btn-success"
                      onClick={handleInputSearch}
                      type="button"
                      id="button-addon2"
                    >
                      <i className="ri-search-line"></i>
                    </button>
                        </div>
                    </div>
                    <div className="col-md-3 mb-5 position-relative ">
                    <div style={{ zIndex: 10, width: "90%" }} className=" position-absolute">
                    <label>Department</label>
                      <Select onChange={(selectedOptions) =>handleMultiSelect("department", selectedOptions)}
                      placeholder={"All"}
                      isMulti
                      options={department}
                      // isDisabled={!filter?.month}
                      value={
                        filter?.department
                          ? filter?.department
                              .split(",")
                              .map((id) =>
                                department.find((option) => option.value == id)
                              )
                          : null
                      }
                    />
                    </div>
                    </div>
                    <div className="col-md-3 mb-5 position-relative ">
                        <div style={{ zIndex: 9, width: "90%" }}className=" position-absolute">
                          <label htmlFor="Location" className="form-label">
                              {" "}Location{" "}
                          </label>
                    <Select onChange={(selectedOptions) => handleMultiSelect("location", selectedOptions)}
                      placeholder={"All"}
                      isMulti
                      options={location}
                      // isDisabled={!filter?.month}
                      value={ filter?.location ? filter?.location.split(",").map((id) =>location.find((option) => option.value == id))
                        : null
                      }
                    />
                    </div>
                    </div>
                    <div className="col-md-3 mb-5 position-relative">
                            <div style={{ zIndex: 8, width: "90%" }}className=" position-absolute">
                          <label htmlFor="Location" className="form-label">
                            Select Month{" "}
                          </label>
                          <Select
                            options={monthOptions}
                            value={filter?.month? monthOptions.find((option) => option.value === filter?.month): null}
                            onChange={(selectOption) =>
                              setFilter({ ...filter, month: selectOption?.value })
                            }
                            placeholder={`Select Month`}/>
                        </div>
                    </div>
                    <div className="col-md-3 mb-5 position-relative">
                      <div style={{ zIndex: 7, width: "90%" }}className=" position-absolute">
                        <label htmlFor="Location" className="form-label">
                          Shift
                        </label>
                        <Select
                        options={shiftRows}
                        value={filter?.location_shift_id? shiftRows.find((option) => option.value === filter?.location_shift_id): null}
                        onChange={(selectOption) =>
                          setFilter({ ...filter, location_shift_id: selectOption?.value })
                        }
                        placeholder={`Select Shift`}/>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className=" row">
                        <div className=" col-md-6">
                          
                                <>
                                <div>
                                    <label>Apply Filter</label>
                                </div>
                                <button type="button" onClick={() => { isPayRollProcess?  getList() : salaryRegisterGetList()}}
                                disabled={loadingFilter || loadingAttednace || loadingSalary}
                                className={`${
                                    !filter?.department &&
                                    !filter?.location &&
                                    !filter?.month &&
                                    !filter?.location_shift_id
                                    ? "disabled"
                                    : ""
                                } w-100 btn btn-info btn-label waves-effect waves-light noWrap`}
                                >
                                <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                {!loadingFilter ? "Filter" : "Loading..."}
                                </button>
                                </>
                            
                        </div>
                        <div className=" col-md-6">
                          <>
                            <div>{" "}
                              <label>Clear Filter</label>{" "}
                            </div>
                            <button
                            type="button"
                            disabled={loadingFilter || loadingAttednace || loadingSalary}
                            className={`w-100 btn noWrap btn-secondary btn-label waves-effect waves-light ${
                                !filter?.department &&
                                !filter?.location &&
                                !filter?.month &&
                                !filter?.location_shift_id
                                ? "disabled"
                                : ""
                            }`}
                            onClick={handleClearAll}
                            >
                            <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i>{" "}
                            Clear
                            </button>
                          </>
                        </div>
                      </div>
                    </div>
                    <div className=" col-md-6">
                      <div className=" d-flex align-items-center justify-content-end mb-3">
                        { decodedData?.includes(3) && ( 
                        <div className=" d-flex gap-3">
                            {showAttendanceButton && isPayRollProcess && (
                                <div style={{}} className="">
                                <div>
                                    {" "}
                                    <label className=" noWrap">
                                    Process Attedance
                                    </label>{" "}
                                </div>
                                {/* {!loadingAttednace ? */}
                                <button
                                    type="button"
                                    // disabled={!filter?.attendanceMonth}
                                    className={`btn noWrap btn-success btn-label waves-effect waves-light ${loadingAttednace ? "disabled" : ""}`}
                                    onClick={() => {
                                    setProcessAttendanceModal(true);
                                    }}
                                >
                                    <i className=" ri-git-repository-line label-icon align-middle fs-16 me-2"></i>{" "}
                                    {!loadingAttednace ? "Process" : "Processing..."}
                                </button>
                                {/*      <button className="btn btn-success btn-load">
                                                        <span className="d-flex align-items-center">
                                                            <span className="spinner-border flex-shrink-0" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </span>
                                                            <span className="flex-grow-1 ms-2">
                                                                Processing...
                                                            </span>
                                                        </span>
                                                    </button>
                                                } */}
                                </div>
                                )}
                            {isPayRollProcess && (
                                    <div style={{}} className="">
                                        <div>{" "}
                                            <label className=" noWrap">Payroll Process</label>{" "}
                                        </div>
                                        {/* {(!loadingPayroll) ? */}
                                        <button type="button" disabled={ selectedRows?.length === 0 ||  !filter?.month || loadingAttednace
                                        }
                                        className={`btn noWrap btn-primary btn-label waves-effect waves-light ${loadingPayroll ? "disabled" : "" }`} onClick={handlePayroll}
                                        >
                                        <i className=" ri-coin-line label-icon align-middle fs-16 me-2"></i>{" "} {!loadingPayroll ? "Process" : "Processing..."}
                                        </button>
                                        
                                      {/* <button className="btn btn-primary btn-load">
                                                <span className="d-flex align-items-center">
                                                    <span className="spinner-border flex-shrink-0" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </span>
                                                    <span className="flex-grow-1 ms-2">
                                                        Processing...
                                                    </span>
                                                </span>
                                            </button>
                                        } */}
                                    </div>
                            )}
                            {!isPayRollProcess && (
                                    <div style={{}} className="">
                                        <div>
                                            <label>Export Excel</label>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={handleExcelDownload}
                                            disabled={!filter?.month || loadingSalary}
                                            className={`btn noWrap btn-success btn-label waves-effect waves-light noWrap`}
                                        >
                                            <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                            {"Export Excel"}
                                        </button>
                                </div>
                            )}
                            { decodedData?.includes(3) && ( 
                            <div style={{}} className="">
                                    <div>
                                        <label className="noWrap"> {isPayRollProcess ? "Salary Register" : "Back To Payroll"}</label>
                                    </div>
                                    {!loadingSalary ? (
                                    <>
                                    {/* <button type="button" disabled={isPayRollProcess ? !filter?.month : false}
                                        className={`btn noWrap btn-primary btn-label waves-effect waves-light ${
                                        loadingSalary ? "disabled" : ""
                                        }`}
                                        onClick={() => {
                                        if (isPayRollProcess && !loadingSalary) {
                                            salaryRegisterGetList();
                                        } else if (!isPayRollProcess) {
                                            setSalaryHeaders([]);
                                            setSalaryRows([]);
                                        }
                                        setIsPayRollProcess(!isPayRollProcess);
                                        }}
                                    >
                                        <i className="ri-book-2-line label-icon align-middle fs-16 me-2"></i>{" "}
                                        {isPayRollProcess ? "Salary Register" : "Back"}
                                    </button> */}
                                    <button type="button" 
                                        className={`btn noWrap btn-success btn-label waves-effect waves-light`}
                                        onClick={() => { navigate(`/SalaryReport?abs=${encodeData(routeId)}`) }}
                                      >
                                        <i className="ri-book-2-line label-icon align-middle fs-16 me-2"></i>{" "}
                                        {"Salary Register"}
                                    </button>
                                    </>
                                    ) : (
                                      <button className="btn btn-primary btn-load">
                                        <span className="d-flex align-items-center">
                                            <span className="spinner-border flex-shrink-0" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                            </span>
                                            <span className="flex-grow-1 ms-2">Loading...</span>
                                        </span>
                                      </button>
                                    )}
                            </div>)}
                        </div>)}
                      </div>
                    </div>
                </div>
                
                  {loadingPayroll && (
                            <div
                            id="myModal"
                            className="modal show"
                            tabIndex={-1}
                            style={{
                                display: "block",
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                            }}
                            aria-labelledby="myModalLabel"
                            aria-hidden="true"
                            >
                              <div
                                  className=" h-100 d-flex justify-content-center align-items-center mt-3"
                                  style={{ width: "100%" }}
                              >
                                  <div className="modal-content" style={{ width: "50%" }}>
                                  <div className="modal-body">
                                      <div className="card-body">
                                      <h3 className=" text-dark">Payroll Process</h3>
                                      <h5 className=" mb-4">
                                          {loadingPayroll ? (
                                          <span className="d-flex align-items-center">
                                              <span
                                              class="spinner-border flex-shrink-0"
                                              role="status"
                                              style={{
                                                  width: "1.2rem",
                                                  height: "1.2rem",
                                                  borderWidth: "2px",
                                              }}
                                              >
                                              <span className="visually-hidden">
                                                  Loading...
                                              </span>
                                              </span>
                                              <span className="flex-grow-1 ms-2">
                                              {uploadProgress == 100
                                                  ? "Almost Completed..."
                                                  : "Processing..."}
                                              </span>
                                          </span>
                                          ) : (
                                          "Completed"
                                          )}
                                      </h5>
                                      <div className="progress animated-progress custom-progress progress-label mt-3">
                                          <div
                                          className="progress-bar bg-success"
                                          role="progressbar"
                                          style={{ width: `${uploadProgress}%` }}
                                          aria-valuenow={uploadProgress}
                                          aria-valuemin={0}
                                          aria-valuemax={100}
                                          >
                                          <div className="label">{uploadProgress}%</div>
                                          </div>
                                      </div>
                                      
                                  </div>
                              </div>
                              </div>
                          </div>
                        </div>
              )}
              <div className="row">
                      {isPayRollProcess ? (
                        <>
                          <div style={{ maxHeight: "65vh", overflowY: "auto" }} className="col-sm-12">
                              <table
                              id="example"
                              className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative"
                              style={{ width: "100%" }}
                              aria-describedby="example_info"
                              >
                              <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                  <tr>
                                  {rows?.length > 0 && decodedData?.includes(3) ? (
                                      <th>
                                      <div className="d-flex gap-1 align-items-center justify-content-center">
                                          <input type="checkbox" className="form-check-input cursorPointer" disabled={loadingPayroll}checked={selectedRows.length === rows.length}
                                          onChange={handleSelectAll}
                                          />
                                          Select{" "}
                                          {selectedRows?.length > 0 && ( <span className="text-white">({selectedRows?.length})
                                          </span>
                                          )}
                                      </div>
                                      </th>
                                  ) : null}
                                  <th className="noWrap">Employee Code</th>
                                  <th>Employee Name</th>
                                  <th>Designation</th>
                                  <th>Department</th>
                                  <th>Location</th>
                                  </tr>
                              </thead>
                              {rows?.length === 0 ? (
                                  <tbody>
                                  <tr>
                                      <td colSpan={6}>
                                      <NoRecords />
                                      </td>
                                  </tr>
                                  </tbody>
                              ) : (
                                  <tbody>
                                  {rows?.map((row, idx) => (
                                      <tr key={row.employee_id}>
                                      { decodedData?.includes(3) && ( 
                                      <td>
                                          <div className="d-flex justify-content-center align-items-center">
                                          <input type="checkbox"
                                              className="form-check-input cursorPointer"
                                              disabled={loadingPayroll}
                                              checked={selectedRows.some(
                                              (val) =>
                                                  val.employee_id === row?.employee_id
                                              )}onChange={() => handleCheckboxChange(row)}
                                          />
                                          </div>
                                      </td>)}
                                      <td>{row.employee_code}</td>
                                      <td>{row.employee_name}</td>
                                      <td>{row.designation_title}</td>
                                      <td>{row.department_title}</td>
                                      <td>{row.location_title}</td>
                                      </tr>
                                  ))}
                                  </tbody>
                              )}
                              </table>
                          
                          </div>
                          <div className="d-flex justify-content-between align-items-center w-100 py-2 px-2">
                            <button disabled={ pagination?.prev === false && pagination?.loadingList === false  ? true : false }
                              type="button"
                              onClick={() => handlePrev()}
                              className={`btn btn-warning btn-label waves-effect waves-light`}
                            >
                              <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                              Previous
                            </button>
                            <div
                              className="col-md-4"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {
                                <small>
                                  Total Records: {pagination?.total_records} | Total
                                  Pages: {pagination?.total_pages} | Current Page:{" "}
                                  {pagination?.page}
                                </small>
                              }
                            </div>
                            <div className="col-md-2">
                              <select className="form-select" onChange={(e) => handleChange(e)}>
                                {Array.from( { length: pagination?.total_pages }, (_, i) => (
                                    <option selected={pagination?.page === i + 1} key={i} value={i + 1} >
                                      Page {i + 1}
                                    </option>
                                  )
                                )}
                              </select>
                            </div>
                            <div className="col-md-2">
                              <select className="form-select" onChange={(e) => handleLimitChange(e)} value={pagination?.limit}
                              >
                                {pagination?.total_records >= 1 && (
                                  <option value={pagination?.total_records}>
                                    All
                                  </option>
                                )}
                                {limitOptions?.map((option) => (
                                  <option key={option} value={option}>
                                    Limit {option}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <button
                              disabled={ pagination?.next === false && pagination?.loadingList === false  ? true : false}
                              type="button"
                              onClick={() => handleNext()}
                              className={`btn btn-primary btn-label waves-effect right waves-light`}
                            >
                              <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />{" "}
                              Next
                            </button>
                          </div>
                        </>
                      ) : (
                      <>
                        <div style={{ maxHeight: '65vh', overflowY: 'auto' }} className="col-sm-12">
                            <table className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped" style={{ minWidth: '100%' }} >
                              <thead className="bg-primary text-light bg-gradient  sticky-top z-1">
                                <tr>
                                  {salaryHeaders?.map((val, idx) => (
                                    <th key={idx} className="noWrap">{val}</th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {salaryRows?.length === 0 ? (
                                  <tr>
                                    <td colSpan={headers?.length || 5}>
                                      <NoRecords />
                                    </td>
                                  </tr>
                                ) : (
                                
                                  salaryRows?.map((row, idx) => (
                                    <tr key={row.employee_id || idx}>
                                      {/* <td>{row.Employee_code}</td>
                                      <td>{row.Employee_name}</td> */}
                                      {row?.map((col, index) => (
                                        <td key={index} className="noWrap">{col}</td>
                                      ))}
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                        </div>
                        {/* <div className="d-flex justify-content-between align-items-center w-100 py-2 px-2">
                          <button disabled={ salaryPagination?.prev === false && salaryPagination?.loadingList === false  ? true : false }
                            type="button"
                            onClick={() => handlePrev()}
                            className={`btn btn-warning btn-label waves-effect waves-light`}
                          >
                            <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />{" "}
                            Previous
                          </button>
                          <div
                            className="col-md-4"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {
                              <small>
                                Total Records: {salaryPagination?.total_records} | Total
                                Pages: {salaryPagination?.total_pages} | Current Page:{" "}
                                {salaryPagination?.page}
                              </small>
                            }
                          </div>
                          <div className="col-md-2">
                            <select className="form-select" onChange={(e) => handleChange(e)}>
                              {Array.from( { length: salaryPagination?.total_pages }, (_, i) => (
                                  <option selected={salaryPagination?.page === i + 1} key={i} value={i + 1} >
                                    Page {i + 1}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                          <div className="col-md-2">
                            <select className="form-select" onChange={(e) => handleLimitChange(e)} value={salaryPagination?.limit}
                            >
                              {salaryPagination?.total_records >= 1 && (
                                <option value={salaryPagination?.total_records}>
                                  All
                                </option>
                              )}
                              {limitOptions?.map((option) => (
                                <option key={option} value={option}>
                                  Limit {option}
                                </option>
                              ))}
                            </select>
                          </div>
                          <button
                            disabled={ salaryPagination?.next === false && salaryPagination?.loadingList === false  ? true : false}
                            type="button"
                            onClick={() => handleNext()}
                            className={`btn btn-primary btn-label waves-effect right waves-light`}
                          >
                            <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />{" "}
                            Next
                          </button>
                        </div> */}
                      </>
                      )}
              
              </div>
               {processAttendanceModal && (
                <div id="myModal" className="modal show" tabIndex={-1} style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }} aria-labelledby="myModalLabel" aria-hidden="true">
                  <div className=" bg-light m-auto mt-3" style={{ width: "40%" }} >
                    <div className="modal-content">
                      <div style={{ padding: "10px 10px 0 10px" }}className="modal-header">
                              <h5 className="modal-title" id="myModalLabel">
                                Attendance Process
                              </h5>
                              <button
                                onClick={() => {
                                  setProcessAttendanceModal(false);
                                  setFilter({
                                    ...filter,
                                    location_shift_id: "",
                                    department: "",
                                    location: "",
                                  });
                                }}
                                disabled={loadingAttednace}
                                className="btn-close"
                                aria-label="Close"
                              ></button>
                      </div>
                      <div className="modal-body">
                          <div style={{ padding: "10px 0px 0 0px" }}className="card-body form-steps">
                                <div className="row">
                                  <div className=" col-md-6">
                                    <label className="noWrap"> Select Month </label>
                                    <Select
                                      options={attendanceMonthOptions}
                                      value={
                                        filter?.attendanceMonth
                                          ? attendanceMonthOptions.find(
                                              (option) =>
                                                option.value ===
                                                filter?.attendanceMonth
                                            )
                                          : null
                                      }
                                      onChange={(selectOption) =>
                                        setFilter({
                                          ...filter,
                                          attendanceMonth: selectOption?.value,
                                        })
                                      }
                                      isClearable={true}
                                      placeholder={`Select Month`}
                                    />
                                  </div>
                                  <div className="col-md-6 ">
                                    <label>Department</label>
                                      <Select onChange={(selectedOptions) =>handleMultiSelect("department", selectedOptions)}
                                      placeholder={"All"}
                                      isMulti
                                      options={department}
                                      isDisabled={!filter?.attendanceMonth}
                                      value={
                                        filter?.department
                                          ? filter?.department
                                              .split(",")
                                              .map((id) =>
                                                department.find((option) => option.value == id)
                                              )
                                          : null
                                      }
                                    />
                                  </div>
                                <div className="col-md-6 ">
                                    <label htmlFor="Location" className="form-label">
                                        {" "}Location{" "}
                                    </label>
                                    <Select onChange={(selectedOptions) => handleMultiSelect("location", selectedOptions)}
                                      placeholder={"All"}
                                      isMulti
                                      options={location}
                                      isDisabled={!filter?.attendanceMonth}
                                      value={ filter?.location ? filter?.location.split(",").map((id) =>location.find((option) => option.value == id))
                                        : null
                                      }
                                    />
                                </div>
                                  <div className="col-md-6">
                                      <label htmlFor="Location" className="form-label">
                                        Shift
                                      </label>
                                      <Select
                                      options={shiftRows}
                                      value={filter?.location_shift_id? shiftRows.find((option) => option.value === filter?.location_shift_id): null}
                                      isDisabled={!filter?.attendanceMonth}
                                      onChange={(selectOption) =>
                                        setFilter({ ...filter, location_shift_id: selectOption?.value })
                                      }
                                      placeholder={`Select Shift`}/>
                                  </div>
                                  <div className="col-md-4 mt-3">
                                    {!loadingAttednace ? (
                                      <button
                                        type="button"
                                        disabled={!filter?.attendanceMonth}
                                        className={`btn noWrap w-100 btn-success btn-label waves-effect waves-light ${
                                          loadingAttednace ? "disabled" : ""
                                        }`}
                                        onClick={() => {
                                          handleAttendance();
                                        }}
                                      >
                                        <i className=" ri-git-repository-line label-icon align-middle fs-16 me-2"></i>{" "}
                                        {!loadingAttednace
                                          ? "Process"
                                          : "Processing..."}
                                      </button>
                                    ) : (
                                      <button className="btn btn-success btn-load">
                                        <span className="d-flex align-items-center">
                                          <span
                                            className="spinner-border flex-shrink-0"
                                            role="status"
                                          >
                                            <span className="visually-hidden">
                                              Loading...
                                            </span>
                                          </span>
                                          <span className="flex-grow-1 ms-2">
                                            Processing...
                                          </span>
                                        </span>
                                      </button>
                                    )}
                                  </div>
                                </div>
                            {/* handleAttendance */}
                          </div>
                      </div>
                        <div className="modal-footer">
                        {/* <button
                            onClick={() => {
                                setProcessAttendanceModal(false)
                            }}
                            className="btn btn-light"
                            >
                            Close
                        </button> */}
                      </div>
                    </div>
                  </div>
                </div>
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayrollProcess;
